import { Box, Checkbox } from "@outschool/backpack";
import { SearchListingsQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { useProductListViewed } from "@outschool/ui-analytics";
import { Container } from "@outschool/ui-legacy-component-library";
import React from "react";

import useSearchResultGalleryExperiment from "../../../hooks/useSearchResultGalleryExperiment";
import { useSearchFilters } from "../../../lib/useSearchFilters";
import { MAX_NUMBER_OF_CLASSES_TO_COMPARE } from "../../classComparison/consts";
import { ActivityListing } from "../../listings/ActivityListing";
import { ListingsProp } from "../common";

export function ListingsWrapper({
  listings,
  tracking: {
    // @ts-ignore
    startIndex = 0,
    // @ts-ignore
    searchUid = null,
    // @ts-ignore
    group = null,
  },
  isComparing,
  selectedListings,
  setSelectedListings,
}: ListingsProp) {
  const { searchResultGalleryExperimentEnabled } =
    useSearchResultGalleryExperiment();
  const trackProductListViewed = useProductListViewed();
  const { t } = useTranslation(
    "client\\components\\search\\desktop\\ListingsHelpers",
  );
  const [index, setIndex] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const { filters } = useSearchFilters();

  const hasPublicFundingFilter = (filters?.fundingPrograms || []).length > 0;
  React.useEffect(() => {
    if (index === listings.length) {
      return;
    }

    trackProductListViewed(
      "search",
      `${group}-${page}`,
      // @ts-ignore TS(2345): Argument of type '{ __typename?: "Listing" | undef... Remove this comment to see the full error message
      listings.slice(index, listings.length),
    );
    setIndex(listings.length);
    setPage(page + 1);
  }, [group, index, listings, page, trackProductListViewed]);

  const onSelectToCompare = (
    listing: SearchListingsQuery["searchListings"]["listings"][0],
  ) => {
    if (selectedListings.includes(listing.activity.uid)) {
      setSelectedListings(
        selectedListings.filter(uid => uid !== listing.activity.uid),
      );
    } else if (selectedListings.length < MAX_NUMBER_OF_CLASSES_TO_COMPARE) {
      setSelectedListings([...selectedListings, listing.activity.uid]);
    }
  };

  if (searchResultGalleryExperimentEnabled) {
    // Pass for now. We will enable this when we are ready to launch the experiment.
    // return (
    //   <SearchResultsGalleryExperiment
    //     listings={listings}
    //     tracking={{ startIndex, searchUid, group }}
    //     isComparing={isComparing}
    //     selectedListings={selectedListings}
    //     setSelectedListings={setSelectedListings}
    //     hasPublicFundingFilter={hasPublicFundingFilter}
    //   />
    // );
  }

  return (
    <Container
      sx={{
        marginBottom: "1em",
      }}
    >
      {listings.map((listing, index) => (
        <Box
          key={listing.activity.uid}
          sx={{
            display: "flex",
            alignItems: "start",
            ...(isComparing && {
              "&:has(:focus-visible)": {
                outline: "2px solid",
                outlineColor: "primary.800",
              },
            }),
          }}
          onClick={() => isComparing && onSelectToCompare(listing)}
        >
          {isComparing && (
            <Checkbox
              checked={selectedListings.includes(listing.activity.uid)}
              disabled={
                selectedListings.length >= MAX_NUMBER_OF_CLASSES_TO_COMPARE &&
                !selectedListings.includes(listing.activity.uid)
              }
              aria-label={t("Compare class: {{classTitle}}", {
                classTitle: listing.activity.title,
              })}
            />
          )}
          <ActivityListing
            listing={listing}
            listingIndex={index}
            trackingProperties={{
              searchUid,
              group,
              order: startIndex + index + 1,
            }}
            disabled={isComparing}
            openInNewTab
            showFundingBadge={hasPublicFundingFilter}
            isSelected={selectedListings.includes(listing.activity.uid)}
          />
        </Box>
      ))}
    </Container>
  );
}
